function AddSwAction(params) {

    $.ajax({
        type: 'post',
        url: '/Stat/Take',
        data: params,
        async: true,
        success: function (dt) {


        }
    });

}

function GetSwPageParams(params) {

    var referrer = document.referrer;
    var location = window.location.pathname;
    var pgType = $("#PgType").val();

    var extraParams = "";

    //alert(pgType);

    switch (pgType) {

        case 'Cat': pgType = "KatalogGoruntuleme"; extraParams += "&CatalogID=" + $("#PID").val(); break;
        case 'Prd': pgType = "UrunGoruntuleme"; extraParams += "&ProductID=" + $("#PID").val(); break;
    }


    var ColorID = $("#ColorID").val();
    var SizeID = $("#SizeID").val();

    if (window.location.hash != undefined && window.location.hash.length > 0) {
        ColorID = GetHashParamValueSW("C");
    }

    if (ColorID != undefined && ColorID.length > 0) {

        extraParams += "&ColorID=" + ColorID;
    }

    if (SizeID != undefined && SizeID.length > 0) {

        extraParams += "&SizeID=" + SizeID;
    }

    if ($("#IsConverted").length > 0) {

        extraParams += "&IsConverted=" + $("#IsConverted").val();
    }

    // alert(ColorID);

    if (location == "/" || location == "") {
        pgType = "AnasayfaGoruntuleme";
    }

    var params = "Location=" + location + "&Referer=" + referrer + "&ActionType=" + pgType + "&PID=" + $("#PID").val() + "&LangID=" + $("#LangID").val() +
    "&ScreenWidth=" + $(window).width() + "&ScreenHeight=" + $(window).height() + extraParams;

    return params
}

$(document).ready(function () {

    //console.log("UseSwStat:" + UseSwStat);

    if (UseSwStat == false && $("#SwStatInp").length > 0) {

        UseSwStat = true;
    }

    if (UseSwStat) {

        params = GetSwPageParams();
        AddSwAction(params);

    }

});